export default "__VITE_ASSET__Bg1uPhsm__"